import React from 'react';
import Link from 'next/link';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const Logo = () => {
	const lastDigitCurrentYear = new Date().getFullYear().toString().slice(2);

	return (
		<Link href="/" passHref>
			{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
			<a className={styles.Logo}>
				<Icon icon="logo" className={styles.Logo__Icon} />
				<span className={styles.Logo__Year}>
					20
					<span className={styles.Logo__TextAccent}>
						{lastDigitCurrentYear}
					</span>
				</span>
			</a>
		</Link>
	);
};

export default Logo;
